// An omitted dataset is a partial refresh, not an empty list of departments.
export function reconcileRoleFilter(data, current) {
  if (!Object.prototype.hasOwnProperty.call(data, "role_types")) return current;
  if (!Array.isArray(data.role_types) || data.role_types.some(
    (role) => !role || typeof role.role_type !== "string"
  )) {
    throw new TypeError("Invalid schedule role_types response");
  }
  const options = data.role_types.map((role) => role.role_type);
  // Preserve intent when the server temporarily has no departments. Empty
  // options alone cannot distinguish "all" from an intentionally empty filter.
  const wasAllSelected = current.options.length === 0
    ? current.selectAll === true
    : current.options.length === current.selected.length &&
      current.options.every((role) => current.selected.includes(role));
  const selected = !current.initialized || wasAllSelected
    ? options
    : current.selected.filter((role) => options.includes(role));
  return { options, selected, initialized: true, selectAll: !current.initialized || wasAllSelected };
}
